import React from 'react';
import {Route, IndexRoute} from 'react-router';

import App from './components/App';
import Search from './components/Search';
import Viewer from './components/Viewer';

export default (
  <Route path="/" component={App}>
    <IndexRoute component={Search} />
    <Route path="r/:sub" component={Viewer} />
    <Route path="r/:sub/:filter" component={Viewer} />
    <Route path="r/:sub/:filter/:search" component={Viewer} />
    <Route path="/search" component={Search} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js